export class Pagination<T> {
  pageSize?: number;
  pageNumber?: number;
  totalPages?: number;
  totalRecords?: number;
  records?: number;
  nextPage?: string | null;
  previousPage?: string | null;
  firstPage?: string;
  lastPage?: string;
  data?: T[];

  constructor(data: Partial<Pagination<T>> = {}) {
    Object.assign(this, data);
  }

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
